<template>
    <el-dialog
        title="查看视频"
        :visible.sync="dialogVisible"
        width="60%"
        @close="handleClose"
    >
        <div class="video-viewer" v-if="videoSrc">
            <video
                ref="videoViewer"
                controls
                width="100%"
                height="100%"
                :src="videoSrc">
            </video>
        </div>  
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" class="btn">关 闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            videoSrc: String,
            value: Boolean,
            input: Function
        },
        data() {
            return {
                dialogVisible: false
            }
        },
        watch: {
            value(val) {
                this.dialogVisible = val
            } 
        },
        methods: {
            handleClose() {
                this.$refs.videoViewer.pause()
                this.$emit('input', false)
            }
        },
    }
</script>

<style lang="scss" scoped>
    .video-viewer {
        width: 100%;
        height: 480px;
    }
</style>